// extracted by mini-css-extract-plugin
export default {"iframeTag":"index_iframeTag_m45-8"};